<template>
  <div>
    <div class="border-bottom mb-3">
      <h1 class="h2">Customers</h1>
    </div>
    <button class="btn btn-primary" @click="newClient()">Add Customers</button>
    <button
      type="button"
      class="btn btn-link"
      v-if="selected.length != 0"
      @click="showDetails"
    >
      Izmijeni
    </button>
    <div class="row pl-3 pr-3 mt-3">
      <div id="vueapp" class="vue-app">
        <v-data-table
          v-model="selected"
          :headers="columns"
          :items="getClients"
          :single-select="true"
          item-key="companyRegistrationId"
          show-select
          class="elevation-1"
        >
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selected: [],
      columns: [
        { value: "companyName", text: "Naziv firme" },
        { value: "email", text: "Email" },
        { value: "companyRegistrationId", text: "PIB" },
        { value: "companyRegistrationCode", text: "PDV" },
        { value: "phoneNumber", text: "Broj telefona" },
        { value: "address", text: "Adresa" }
      ]
    };
  },
  methods: {
    showDetails() {
      this.$store.dispatch("editMode", true);
      this.$store.dispatch("editClient", this.selected[0]);
    },
    newClient() {
      this.$router.push("/add-customer");
    }
  },
  computed: {
    getClients() {
      return this.$store.getters.getClients;
    }
  },
  created() {
    this.$store.dispatch("takeAllClients");
  }
};
</script>
